export type Gender = 'women' | 'men' | 'children'

export type CampaignNavigationLinks = {
  campaignId: string
  nameKey: string
  url: string
  gender: Gender
}

export enum GenderEnum {
  Women = 'women',
  Men = 'men',
  Children = 'children'
}

export const genderCategoryMap: Record<Gender, string> = {
  women: '3',
  men: '20',
  children: '101'
}

export const genderCategoryTestMap: Record<
  'men' | 'women' | 'children',
  string
> = {
  men: '20',
  women: '3',
  children: '101'
}

export enum GenderNews {
  WomenNews = '/zeny?news=1',
  MenNews = '/muzi?news=1',
  ChildrenNews = '/category/101?news=1'
}

export const campaignNavigationLinks: CampaignNavigationLinks[] = [
  // WOMEN CAMPAIGN
  {
    campaignId: '318',
    nameKey: 'Campaign.NavigationMenu.denimWorld',
    url: '/campaign/318?gender%5B%5D=12',
    gender: 'women'
  },
  {
    campaignId: '406',
    nameKey: 'Campaign.NavigationMenu.officeLook',
    url: '/campaign/406?gender%5B%5D=12',
    gender: 'women'
  },
  {
    campaignId: '897',
    nameKey: 'Campaign.NavigationMenu.chicbags',
    url: '/campaign/chicbags',
    gender: 'women'
  },
  {
    campaignId: '139',
    nameKey: 'Campaign.NavigationMenu.leatherSkin',
    url: '/campaign/leather-in-the-game?gender[]=12',
    gender: 'women'
  },
  {
    campaignId: '852',
    nameKey: 'Campaign.NavigationMenu.parfums',
    url: '/campaign/852?gender%5B%5D=12',
    gender: 'women'
  },
  // MEN CAMPAIGN
  {
    campaignId: '928',
    nameKey: 'Campaign.NavigationMenu.menBags',
    url: '/campaign/bags-for-men',
    gender: 'men'
  },
  {
    campaignId: '318',
    nameKey: 'Campaign.NavigationMenu.denimWorld',
    url: '/campaign/318?gender%5B%5D=13',
    gender: 'men'
  },
  {
    campaignId: '406',
    nameKey: 'Campaign.NavigationMenu.officeLook',
    url: '/campaign/office-look?gender%5B%5D=13',
    gender: 'men'
  },
  {
    campaignId: '777',
    nameKey: 'Campaign.NavigationMenu.sportCool',
    url: '/campaign/sportcool-outfity?gender%5B%5D=13',
    gender: 'men'
  },
  {
    campaignId: '852',
    nameKey: 'Campaign.NavigationMenu.parfums',
    url: '/campaign/852?gender%5B%5D=13',
    gender: 'men'
  },
  // CHILDREN CAMPAIGN
  {
    campaignId: '929',
    nameKey: 'Campaign.NavigationMenu.denimKids',
    url: '/campaign/929',
    gender: 'children'
  },
  {
    campaignId: '777',
    nameKey: 'Campaign.NavigationMenu.sportCool',
    url: '/campaign/sportcool-outfity?gender%5B%5D=14',
    gender: 'children'
  },
  {
    campaignId: '1309',
    nameKey: 'Campaign.NavigationMenu.girlsUnderwear',
    url: '/category/1309',
    gender: 'children'
  },
  {
    campaignId: '1311',
    nameKey: 'Campaign.NavigationMenu.boysUnderwear',
    url: '/category/1311',
    gender: 'children'
  }
]
